import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';

import { Typography, Link } from '@occc/ui-design-system';

import { routeCreator } from '../utils';

export const EmptyLocationGroup = () => {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' sx={{ height: 460 }}>
      <Typography variant='subtitle1' align='center' paragraph>
        You can add locations to this group from the{' '}
        <Link component={RouterLink} to={routeCreator.list()} underline='always'>
          Site Management
        </Link>{' '}
        page.
      </Typography>
    </Box>
  );
};
